/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-quotes */
/* eslint-disable linebreak-style */
import React from 'react'
import { useSelector } from 'react-redux'
import {Form, FormGroup, Input, Button} from 'reactstrap'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

// import excelIcon from '../../../assests/images/excel-icon.svg'
import addlIcon from '../../../assests/images/add-white-icon.svg'
// import calendarIcon from '../../../assests/images/calendar-icon.svg'

import constants from '../../../constants'

function UserHeader (props) {
  const {search,handleSearch,handleKeyPress,
    // startDate,
    // endDate,
    // handleDateRangePicker,
    // onExport,
    title
  } = props
  const adminData = useSelector((state) => state.auth.adminData)
  const userPermission = (adminData.aPermissions && adminData.aPermissions.length && adminData.aPermissions.find((e) => e.eKey === 'USERS').eType) ? adminData.aPermissions.find((e) => e.eKey === 'USERS').eType : adminData.eType === 'SUPER' ? constants.WRITE_PERMISSION : constants.NO_PERMISSION

  return (
    <div className="header-block">
      <h2>{title || 'Transaction Management'}</h2>
      <div className="filter-block d-flex justify-content-between align-items-start">
        <Form className="d-flex">
          <FormGroup>
            <Input
              className="search-box"
              name="search"
              placeholder="Search"
              onKeyPress={handleKeyPress}
              value={search}
              onChange={handleSearch}
            />
          </FormGroup>
        </Form>

      
        <div className="btn-list">
          <div className="filter-block d-flex justify-content-end">
            <div className="btn-list">
              {(userPermission === constants.WRITE_PERMISSION && title === 'Admin User') ? (
                <Button tag={Link} to="/users/admin-user/add-admin-user" className="theme-btn icon-btn">
                  <img src={addlIcon} alt="add" />
                  Add Admin User
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

UserHeader.propTypes = {
  handleSearch: PropTypes.func,
  handleDateRangePicker: PropTypes.func,
  onExport: PropTypes.func,
  search: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  title: PropTypes.string,
  handleKeyPress: PropTypes.func
}

export default UserHeader
